import { RESET_STATE, RESET_STATE_WITHOUT_AUTH } from "./actionsType";

export const resetStateAction = () => ({
    type: RESET_STATE,
})
export const resetStateWithoutAuthAction = () => ({
    type: RESET_STATE_WITHOUT_AUTH,
})
